import { render, staticRenderFns } from "./cupon-puntos.vue?vue&type=template&id=700508de"
import script from "./cupon-puntos.vue?vue&type=script&lang=js"
export * from "./cupon-puntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports